export const theme = {
  breakpoints: {
    mobile: '375px',
    tablet: '768px',
    desktop: '960px',
  },
  colors: {
    black: '#000000',
    black40: '#00000066',
    blue: '#00a8e9',
    darkBlue: '#3f51b5',
    grey: '#9E9E9E',
    lightBlue: '#f8fafc',
    white: '#FFFFFF',
  },
};

export type Theme = typeof theme;
